import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/app/jds")({
  component: () => <Navigate to="/app/jobs" replace />,
});
